import axios from "axios";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";

export function verifyCorporateToken(endpoint, pageName) {
  eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
    request_type: pageName,
  });
  return axios
    .post(endpoint, {})
    .then((res) => res.status)
    .then(() => {
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: pageName,
        request_status: "success",
      });
      return true;
    })
    .catch((err) => {
      const errorMessage =
        err.response?.data?.description ||
        err.response?.data?.message ||
        err.response?.data;
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
        request_type: pageName,
        request_status: "failed",
        error_code_string: err.response?.status?.toString(),
        error_description: errorMessage,
      });
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_ERROR, {
        page_name: pageName,
        error_message: errorMessage,
      });
      return false;
    });
}
